import { Chip, styled } from '@mui/material';

import TrendingDownRoundedIcon from '@mui/icons-material/TrendingDownRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const CustomChip = styled(Chip)(({ theme, risk }) => ({
	fontWeight: 500,
	fontSize: 13,
	minWidth: 110,
	color: risk === 'ok' ? 'rgb(70, 170, 10)' : (risk === 'understock' ? 'rgb(250, 10, 10)' : 'rgb(245, 182, 10)'),
	backgroundColor: risk === 'ok' ? 'rgba(70, 170, 10, 0.15)' : (risk === 'understock' ? 'rgba(250, 10, 10, 0.15)' : 'rgba(245, 182, 10, 0.15)'),
}));

const CustomChipSelected = styled(Chip)(({ theme, risk }) => ({
	fontWeight: 500,
	fontSize: 13,
	minWidth: 110,
	color: risk === 'ok' ? 'rgba(70, 170, 10, 0.7)' : (risk === 'understock' ? 'rgba(250, 10, 10, 0.7)' : 'rgba(245, 182, 10, 0.7)'),
	border: '1px solid',
	backgroundColor: 'transparent',
}));

const config = {
	ok: {
		icon: <CheckRoundedIcon fontSize="small" />,
		risk: 'ok'
	},
	understock: {
		icon: <TrendingDownRoundedIcon fontSize="small" />,
		risk: 'understock'
	},
	overstock: {
		icon: <TrendingUpRoundedIcon fontSize="small" />,
		risk: 'overstock'
	}
}

export { CustomChip, CustomChipSelected, config }